import React from 'react';
import { Link } from 'react-router';
import styles from './styles/AnonHeader.module.scss';

import logo from '../../logo.svg';

const AnonHeader: React.FunctionComponent = () => (
  <Link to="/" className={styles.logo}>
    <img src={logo} alt="Lumme Energia" />
  </Link>
);

export default AnonHeader;
